import { createCommand } from '@commander-js/extra-typings';
import type { CommandServices } from '@wix/cli-command-contract';
import { createI18nT } from '../i18n.js';

export const installCommand = (
  services: CommandServices,
  cliVersion: string
) => {
  const t = createI18nT();

  return createCommand('install')
    .description(t('site_install_command_def.description'))
    .argument('[package]', t('site_install_command_def.argument.package'))
    .option('--yarn', t('site_install_command_def.option.yarn'))
    .option('--npm', t('site_install_command_def.option.npm'))
    .action(async (packageName, opts, command) => {
      const { runCommand } = await import('./run-command.js');
      const { install } = await import('../install/index.js');

      await runCommand(command, services, cliVersion, (model) =>
        install(model, services, opts, packageName)
      );
    });
};
